/**-- external -- */
import PropTypes from "prop-types";
import { useKeyboardShortcuts } from "@toddle-edu/ds-web";

//TODO: Add this to ds to use it for class based components
const KeyboardShortcuts = ({
  handleShortcuts,
  children,
  maxShortcutLength = 1,
  areGlobalShortcuts,
  areShortcutsEnabled,
  shouldExecuteInCapturePhase,
}) => {
  useKeyboardShortcuts({
    handleShortcuts,
    maxShortcutLength,
    areGlobalShortcuts,
    areShortcutsEnabled,
    shouldExecuteInCapturePhase,
  });

  return children;
};

KeyboardShortcuts.propTypes = {
  handleShortcuts: PropTypes.func,
  children: PropTypes.element,
  maxShortcutLength: PropTypes.number,
  areGlobalShortcuts: PropTypes.bool,
  shouldExecuteInCapturePhase: PropTypes.bool,
};

KeyboardShortcuts.defaultProps = {
  handleShortcuts: () => true,
  children: null,
  maxShortcutLength: 1,
  areGlobalShortcuts: false,
};

export default KeyboardShortcuts;
